import { Outlet } from 'react-router-dom'
import { Header } from './Header/index'
import { Footer } from './Footer/index'
import { BottomNav } from './BottomNav/index'
import ConnectionStatus from './ConnectionStatus'
import { ProviderHierarchy } from '../providers/ProviderHierarchy'
import { useAuth } from '../hooks/useAuth'
import { AuthModal, UserProfileModal } from './auth'
import { ModalContainer } from './Modal'
import { Toaster } from 'react-hot-toast'
import { useTrialStatus } from '../hooks/useTrialStatus'
import TrialExpiredPopup from './TrialExpiredPopup'

function RootLayoutInner() {
  const {
    isAuthModalOpen,
    authModalMode,
    authRedirectUrl,
    closeAuthModal,
    isUserProfileOpen,
    closeUserProfile
  } = useAuth();
  const trialStatus = useTrialStatus();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header trialStatus={trialStatus} />
{/* Small top padding for visual breathing room, bottom padding for mobile nav */}
      <div className="flex-1 flex flex-col pt-4 md:pt-6 pb-[calc(48px+env(safe-area-inset-bottom))] md:pb-0">
        {import.meta.env.DEV && <ConnectionStatus />}
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
      <BottomNav />
      
      {/* Auth Modal */}
      <AuthModal
        isOpen={isAuthModalOpen}
        mode={authModalMode}
        onClose={closeAuthModal}
        redirectUrl={authRedirectUrl}
      />
      
      {/* User Profile Modal */}
      <UserProfileModal
        isOpen={isUserProfileOpen}
        onClose={closeUserProfile}
      />
      
      {/* Game Modals */}
      <ModalContainer />
      
      {/* Trial expired popup — shown on all authenticated pages when trial has ended */}
      <TrialExpiredPopup status={trialStatus} />

      {/* Toast notifications */}
      <Toaster position="top-center" />
    </div>
  )
}

export default function RootLayout() {
  return (
    <ProviderHierarchy>
      <RootLayoutInner />
    </ProviderHierarchy>
  )
}